const regexEmoji =
  /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;

let emojiMap: Record<string, string> | null = null;

const emojiPromise = fetch('/static/assets/json/emoji-names.json')
  .then((res) => res.json())
  .then((data) => {
    emojiMap = data;
  })
  .catch((e) => {
    console.error('Failed to load emoji map');
    console.error(e);
    emojiMap = {};
  });

export const replaceEmojis = async (text: string) => {
  if (!emojiMap) {
    await emojiPromise;
  }

  return text.replace(regexEmoji, (match) => {
    const emoji = emojiMap![match];
    return emoji ?? '';
  });
};
